import { ShowButton, TextField } from '@refinedev/antd';
import { Space, Tag } from 'antd';
import { ColumnType } from '@/types';
import dayjs from 'dayjs';
import {
  DeleteOutlined,
  MinusOutlined,
  PlayCircleOutlined,
} from '@ant-design/icons';
import { DeleteButton } from '@/components/buttons/delete';

export const getColumns = (
  translate: (key: string) => string,
  isLoadingDeactivate: boolean,
  handleDeactivate: (is_active: boolean) => void,
  setDeactivateId: (id: string) => void,
  deactivateId: string
): ColumnType[] => [
  {
    title: translate('listing-users.id'),
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: translate('listing-users.name'),
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: translate('listing-users.email'),
    dataIndex: ['account', 'email'],
    key: 'email',
  },
  {
    title: translate('listing-users.status'),
    dataIndex: ['account', 'status'],
    key: 'status',
    render: (status: string) => (
      <Tag
        color={
          status === 'APPROVED'
            ? 'green'
            : status === 'REJECTED'
              ? 'red'
              : 'orange'
        }
      >
        {status === 'PENDING'
          ? translate('listing-users.pending')
          : status === 'APPROVED'
            ? translate('listing-users.approved')
            : translate('listing-users.rejected')}
      </Tag>
    ),
  },
  {
    title: translate('listing-users.isActive'),
    dataIndex: ['account', 'is_active'],
    key: 'is_active',
    render: (is_active: boolean) => (
      <Tag color={is_active ? 'green' : 'red'}>
        {is_active
          ? translate('listing-users.active')
          : translate('listing-users.inactive')}
      </Tag>
    ),
  },
  {
    title: translate('listing-users.universityId'),
    dataIndex: 'university_id',
    key: 'university_id',
  },
  {
    title: translate('listing-users.dateOfBirth'),
    dataIndex: 'date_of_birth',
    key: 'date_of_birth',
    render: (date: string) => dayjs(date).format('YYYY-MM-DD'),
  },
  {
    title: translate('listing-users.gender.title'),
    dataIndex: 'gender',
    key: 'gender',
    render: (gender: string) => (
      <TextField value={translate(`show-user.fields.gender.${gender}`)} />
    ),
  },
  {
    title: translate('listing-users.quote'),
    dataIndex: 'quote',
    key: 'quote',
    render: (quote: string) => {
      return quote ? (
        <TextField value={quote.slice(0, 10)} />
      ) : (
        <MinusOutlined />
      );
    },
  },
  {
    title: translate('listing-users.className'),
    dataIndex: ['school_class', 'name'],
    key: 'className',
  },
  {
    title: translate('listing-users.classYear'),
    dataIndex: ['school_class', 'year_range'],
    key: 'classYear',
    render: (year_range: string) => {
      return year_range ? year_range : <MinusOutlined />;
    },
  },
  {
    title: translate('listing-users.actions'),
    dataIndex: 'actions',
    key: 'actions',
    render: (_, record) => {
      return record?.profile?.id ? (
        <Space>
          <ShowButton
            recordItemId={record?.profile?.id}
            hideText
            size="small"
          />
          <DeleteButton
            icon={
              record.account.is_active ? (
                <DeleteOutlined className="text-red-500" />
              ) : (
                <PlayCircleOutlined className="text-green-500" />
              )
            }
            className={
              record.account.is_active ? 'border-red-500' : 'border-green-500'
            }
            hideText
            size="small"
            isLoading={deactivateId === record.id ? isLoadingDeactivate : false}
            onClick={() => {
              setDeactivateId(record.id);
            }}
            onConfirm={() => {
              handleDeactivate(record.account.is_active);
            }}
            confirmOkText={
              record.account.is_active
                ? translate('listing-users.deactivate')
                : translate('listing-users.activate')
            }
          />
        </Space>
      ) : null;
    },
  },
];
